/*
 * Copyright (C) 2018 - 2023 Entgra (Pvt) Ltd, Inc - All Rights Reserved.
 *
 * Unauthorised copying/redistribution of this file, via any medium is strictly prohibited.
 *
 * Licensed under the Entgra Commercial License, Version 1.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       https://entgra.io/licenses/entgra-commercial/1.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import React, { useContext } from 'react';
import defenderStyles from '../../styles.module.css';
import { Button } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { DeviceDetailsContext } from '../../../../index';
import { useTranslation } from 'react-i18next';

export const Signature = props => {
  const { t } = useTranslation();
  const deviceDetails = useContext(DeviceDetailsContext);

  const updateSignature = () => {
    props.triggerScans('DEFENDER_UPDATE_SIGNATURE');
  };

  return (
    <div
      style={{ marginTop: 20, marginLeft: 160 }}
      className={defenderStyles.boxContainer}
    >
      <div className={defenderStyles.detailsSignature}>
        <div>
          <b>{t('label_expirationSignature')}</b>
        </div>
        {deviceDetails.device.deviceInfo &&
        deviceDetails.device.deviceInfo.deviceDetailsMap &&
        deviceDetails.device.deviceInfo.deviceDetailsMap
          .SIGNATURE_OUT_OF_DATE === 'true' ? (
          <span>
            <CloseCircleOutlined
              className={defenderStyles.closeCircleOutlined}
            />
            <div>{t('label_updateSignatureRequired')}</div>
            <Button onClick={updateSignature}>
              {t('label_updateSignature')}
            </Button>
          </span>
        ) : (
          <span>
            <CheckCircleOutlined
              className={defenderStyles.checkCircleOutlined}
            />
            <div>{t('label_notOutOfDate')}</div>
            <Button onClick={updateSignature}>
              {t('label_updateSignature')}
            </Button>
          </span>
        )}
      </div>
    </div>
  );
};

export default Signature;
